var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('dialog-base',[_c('div',{staticClass:"mod-egg"},[_c('div',{staticClass:"tip"},[_vm._v(" "+_vm._s(_vm.tipMap[_vm.num])+" ")]),_c('div',{staticClass:"btn-red"},[_c('span',{staticClass:"text",on:{"click":_vm.close}},[_vm._v("继续寻宝")])])])])}
var staticRenderFns = []

export { render, staticRenderFns }